import { z } from 'zod';
import { FLOW_TRIGGER } from '../constants/flowTriggers';
import { isScheduledTimeValid } from '../logic/timeValidation.logic';

// Tag schema matching the Tag interface
const tagSchema = z.object({
    name: z.string(),
    type: z.literal('pseudo').optional(),
    data: z.any().optional(),
    excluded: z.number().optional(),
});

export const flowFormSchema = z.object({
    flowName: z.string().trim().min(1, 'Flow name is required').max(100, 'Flow name is too long'),
    selectedTrigger: z.enum([FLOW_TRIGGER.CHECKOUT, FLOW_TRIGGER.TIME, FLOW_TRIGGER.CART_ABANDONMENT]),
    selectedProducts: z.array(z.number()).optional(),
    selectedExcludeProducts: z.array(z.number()).optional(),
    selectedDate: z.string().optional(),
    selectedTime: z.number().optional(),
    selectedTimezone: z.string().optional(),
    tags: z.array(tagSchema).optional(),
});

export const flowFormSchemaWithTimeValidation = flowFormSchema.refine(
    data => {
        // Only validate time for TIME trigger
        if (data.selectedTrigger !== FLOW_TRIGGER.TIME) {
            return true;
        }

        // Skip validation if required fields are missing
        if (!data.selectedDate || data.selectedTime === undefined) {
            return true;
        }

        const validation = isScheduledTimeValid(data.selectedDate, data.selectedTime);
        return validation.isValid;
    },
    data => {
        if (data.selectedTrigger === FLOW_TRIGGER.TIME && data.selectedDate && data.selectedTime !== undefined) {
            const validation = isScheduledTimeValid(data.selectedDate, data.selectedTime);
            return {
                message: validation.error || 'Please schedule the broadcast for at least 10 minutes in the future.',
                path: ['selectedTime'],
            };
        }
        return {
            message: 'Please schedule the broadcast for at least 10 minutes in the future.',
            path: ['selectedTime'],
        };
    }
);

export type FlowFormData = z.infer<typeof flowFormSchema>;
